export default __webpack_public_path__ + "static/media/slide3.e89cebd5.jpg";